import { useState } from "react";
import { errorMessage } from "../../utils/utils";
import Spinner from "../../components/spinner";
import { Bounce, toast, ToastContainer } from "react-toastify";
import api from "../../utils/api";
import AuthShell, { authButton, authInput, authLabel, authLink } from "../../components/AuthShell";

export default function PasswordReset() {

    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState('');

    const [error, setError] = useState('');

    async function sendReset(e: any) {
        e.preventDefault();

        setError('');
        setLoading(true);

        try {
            const res = await api.post(`/user/password/reset`, { email });

            const json = await res.json();
            if (res.ok) {
                toast.success(json.message);
            } else {
                setError(errorMessage(json));
            }
        } catch (err) {
            setError(errorMessage(err));
        }
        setLoading(false);
    }

    return (
        <>
            <AuthShell
                title="Reset your password"
                subtitle="Enter your email address below, and if the account exists, we’ll send you a link to reset your password."
                footer={<>
                    <div className="text-slate-500">
                        Remembered it? <a href="/signin" className={authLink}>Sign In</a>
                    </div>
                    <a href="https://kptd.ph/remote" className="font-semibold text-slate-500 transition hover:text-slate-900">
                        Go back to home
                    </a>
                </>}>

                <form onSubmit={sendReset}>

                    <div className="mb-5">
                        <label htmlFor="email" className={authLabel}>Email address</label>
                        <div className="mt-1.5">
                            <input
                                id="email"
                                name="email"
                                type="email"
                                required
                                value={email}
                                disabled={loading}
                                autoComplete="email"
                                placeholder="name@domain.com"
                                className={authInput}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>
                    </div>

                    {error && (
                        <div className="mb-5 rounded-xl bg-red-50 px-4 py-3 text-center text-sm font-medium text-red-700 ring-1 ring-red-100">
                            <div dangerouslySetInnerHTML={{ __html: error }} />
                        </div>
                    )}

                    <button type="submit" disabled={loading} className={authButton}>
                        {loading && <Spinner className="w-4 h-4" />} Send reset link
                    </button>

                </form>

            </AuthShell>

            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={true}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                transition={Bounce}
            />
        </>
    )
}
